import { NODE_NAME_ADDITIONAL_GUEST_PREFIX_REGEXP } from 'common/entities/formNode/nodeNames';

/**
 * @param  {Object} node
 * @return {bool}
 */
export const isAdditionalGuestInfoNode = (node) => NODE_NAME_ADDITIONAL_GUEST_PREFIX_REGEXP.test(node.name);

/**
 * From a node with name 'additional-guest[n]something' returns 'n'
 * @param  {Object} node
 * @return {string}
 */
export const getReferencedAdditionalGuestNumber = (node) =>
    node.name.replace(NODE_NAME_ADDITIONAL_GUEST_PREFIX_REGEXP, '$2');

/**
 * Replaces recursively the referenced guest name in node names for the given one.
 * @param  {Object} node - denormalized node
 * @param  {string} guestNumber
 * @return {Object}
 */
export const replaceAdditionalGuestNumber = (node, guestNumber) => ({
    ...node,
    name: node.name.replace(NODE_NAME_ADDITIONAL_GUEST_PREFIX_REGEXP, `$1[${guestNumber}]$3`),
    children: (node.children || []).map((child) => replaceAdditionalGuestNumber(child, guestNumber)),
});
